import { updateInventoryTransactionType } from "../../api/inventoryService";

export const useUpdateInventoryTransactionType = (successCallback) => {
    const update = async (id, data) => {
        try {
            const updatedRecord = await updateInventoryTransactionType(id, data);
            if (successCallback)
            {
                successCallback(updatedRecord);
            }
            return updatedRecord;
        } catch (error) {
            console.error("Failed to update inventory transaction type:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { update };
};